<section class="grid gap-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <page-title [title]="'Affiliate management'"></page-title>
    </div>

    <div class="flex items-center gap-3">
      @if (canCreate()) {
        <!-- <a mat-flat-button routerLink="/affiliates/new">Create affiliate</a> -->
        <button matButton="filled" type="button" class="mom-danger" (click)="sharedUtils.navigateTo('/affiliates/new')">
          <mat-icon>add</mat-icon>
          Create affiliate
        </button>
      }
    </div>
  </div>

  <affiliate-table
    [affiliates]="affiliateStore.affiliates()"
    [loading]="affiliateStore.loading()"
    [searchTerm]="affiliateStore.affiliatesSearch()"
    [pageNumber]="affiliateStore.affiliatesPageNumber()"
    [pageSize]="affiliateStore.affiliatesPageSize()"
    [totalCount]="affiliateStore.affiliatesTotalCount()"
    [totalPages]="affiliateStore.affiliatesTotalPages()"
    [canDeactivate]="canDeactivate()"
    [canActivate]="canActivate()"
    [canUpdate]="canUpdate()"
    [actionAffiliateId]="actionAffiliateId()"
    (refreshed)="refresh()"
    (searchChanged)="searchAffiliates($event)"
    (pageChanged)="changePage($event)"
    (toggled)="toggleAffiliateActive($event)" />
</section>
